Ext.define('SA.ActiveTabId', {
    singleton: true,

    get() {
        return SA.LocalStorage.get('activeTabId');
    },

    set(id) {
        SA.LocalStorage.set('activeTabId', id);
    }
});